module.exports = __webpack_public_path__ + "static/media/kiwamis.c42c7836.jpg";